exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.color-prev[data-v-5548c060] {\n  height: 50px;\n  width: 50px;\n  border-radius: 50px;\n  margin: 0 auto;\n}\n", ""]);

// exports
